export const BOT = {
    MESSAGE_TYPE: {
        COMMANDS: {
            REFRESH: 'cmd_refresh',
            TRANSFER: 'cmd_transfer',
            CHANGE: 'cmd_change_bot',
            FINISH: 'cmd_finish'
        },

        CONTROLS: {
            TEXT: 'ctrl_text',
            BUTTONS: 'ctrl_buttons',
            INPUTS: 'ctrl_inputs',
            RADIOBUTTON_INPUTS: 'ctrl_radiobutton_inputs',
            RADIOBUTTONS: 'ctrl_radiobuttons'
        }
    },

    STATUS_CODE: {
        OK: 0,
        WARN: 1,
        ERROR: 2
    }
};
